import { combineReducers } from 'redux';

/**
 *  Students
 * */
import localStorageContainer from './actions/generic-container';
import onDemandTutoring from './apis/answer-on-demand';
import bookingsApis from './apis/bookings-endpoints';
import bridgePlanApis from './apis/bridge-plan';
import checkoutApis from './apis/checkout-apis';
import customerApis from './apis/customer';
import customerPersistentApi from './apis/customer-persistent-api';
import unAuthCustomerApis from './apis/unauth-customer';

const createRootReducer = () =>
  combineReducers({
    [localStorageContainer.name]: localStorageContainer.reducer,
    [customerApis.reducerPath]: customerApis.reducer,
    [onDemandTutoring.reducerPath]: onDemandTutoring.reducer,
    [bridgePlanApis.reducerPath]: bridgePlanApis.reducer,
    [checkoutApis.reducerPath]: checkoutApis.reducer,
    [bookingsApis.reducerPath]: bookingsApis.reducer,
    [unAuthCustomerApis.reducerPath]: unAuthCustomerApis.reducer,
    [customerPersistentApi.reducerPath]: customerPersistentApi.reducer,
  });

const rootReducer = createRootReducer();

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
